export interface ModelViewerTextureUpdate {
    revision?: number
    sequence: number
}

type TextureUpdateListener = (update: ModelViewerTextureUpdate) => void

export interface ModelViewerTextureUpdateSignal {
    publish: (revision?: number) => void
    subscribe: (listener: TextureUpdateListener) => () => void
}

/**
 * Bridges the DOM-side texture compositor to the separate R3F root without
 * routing every live Design Lab update through React state and reconciliation.
 */
export const createModelViewerTextureUpdateSignal = (
):ModelViewerTextureUpdateSignal => {
    const listeners = new Set<TextureUpdateListener>()
    let latestUpdate:ModelViewerTextureUpdate|null = null
    let sequence = 0

    return {
        publish: (revision?:number) => {
            const update = {
                revision,
                sequence: ++sequence,
            }
            latestUpdate = update
            listeners.forEach(listener => listener(update))
        },
        subscribe: (listener:TextureUpdateListener) => {
            listeners.add(listener)
            if(latestUpdate !== null) {
                listener(latestUpdate)
            }

            return () => {
                listeners.delete(listener)
            }
        },
    }
}
